// @ts-strict-ignore
import * as React from 'react';
import { clsx } from 'clsx';
import { PropertyValuesScreenReact } from 'common/widgets/property-filter-menu/property-values-screen';
import { SelectTheme } from 'common/components/select/constants';
import { SelectReact } from 'common/components/select';
import { CommitPropertyFilterEvent } from 'common/widgets/property-filter-menu/property-values-screen/types';
import { MappedPropertyValues } from 'common/report/constants';
import { InputReact } from 'common/components/input';
import { InputChangeEvent, InputSize } from 'common/components/input/types';
import { useTranslation } from 'common/i18n/hooks';
import { FilterValueProps } from '../types';
export function FilterListValue(props: FilterValueProps) {
  const {
    t
  } = useTranslation();
  const label = props.filter.getLabelParts().slice(2).map(item => item.label).join(" ");

  /**
   * Historically, list filters are always treated as list of strings, which only
   * require a string input, there is one exception where `Messages Sent` renders
   * a value picker for selecting one of the different messages available in the project
   * we handle that case by rendering `mp-properties-value-screen` for now
   */
  if (props.filter.propertyName === MappedPropertyValues.Campaigns) {
    return <SelectReact className={clsx("filter-value-select", {
      'is-placeholder': !props.filter.isValid()
    })} elref='filterValueSelect' open={props.isActive} theme={props.hasNewUI ? SelectTheme.Tertiary : SelectTheme.Select} neverShowCaret readonly={props.readonly} selectedOption={props.filter.isValid() ? label : t("query-builder.value-placeholder")} onMenuChange={ev => props.onSelectMenuChange(ev)}>
        {props.isActive && <PropertyValuesScreenReact elref='filterValue' slot='body' displayValueOnly eventNames={props.eventNames} propertyFilter={props.filter.getAttributes()} projectId={props.projectId} workspaceId={props.workspaceId} onCommitPropertyFilter={(ev: CommitPropertyFilterEvent) => props.onChange(ev.detail.propertyFilter.filterValue)} />}
      </SelectReact>;
  }
  return <InputReact className={clsx("filter-input", {
    'is-placeholder': !props.filter.isValid()
  })} elref='filterInput' placeholder='value' size={InputSize.Medium} autoFocus={!props.filter.isValid()} selectOnFocus readonly={props.readonly} value={props.filter.filterValue as string} onChange={(ev: InputChangeEvent) => {
    const input = ev.target as HTMLInputElement;

    // when the updated value is not a valid input, revert back to previously committed input
    if (ev.detail.value !== null) {
      props.onChange(ev.detail.value);
    } else {
      input.value = props.filter.filterValue as string;
    }
    input.blur(); // user has most likely pressed "Enter", in which case they are likely finished so we want to lose focus
  }} data-sentry-element="InputReact" data-sentry-component="FilterListValue" data-sentry-source-file="list.tsx" />;
}